import request from '@/utils/request';

// 获取普客客服数据
export function getNormalDataApi(params) {
  return request({
    url: '/admin/normal_service_data',
    method: 'get',
    params: params,
  });
}

// 获取vip客服数据
export function getVipDataApi(params) {
  return request({
    url: '/admin/vip_service_data',
    method: 'get',
    params: params,
  });
}
// 获取质检客服数据
export function getQualifyDataApi(params) {
  return request({
    url: '/admin/qualify_service_data',
    method: 'get',
    params: params,
  });
}
// 获取工单客服数据
export function getWorksnDataApi(params) {
  return request({
    url: '/admin/worksn_service_data',
    method: 'get',
    params: params,
  });
}
